import { useLocationStore as useLocationStoreLegacy } from '@global-store/stores/location'
import { useLocationStore } from '@shared/global-store/stores/location/location'

import { type Locale, defaultLocale } from '@fond-of/locale'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Translations = Partial<Record<Locale, any>>

export const translate = (
  translations: Translations,
  term: string,
  props: Record<string, string> = {}
) => {
  const { isShopify } = useLocationStoreLegacy()

  const locale = !isShopify
    ? useLocationStoreLegacy()?.currentLocale
    : useLocationStore()?.locale

  let translation = getTranslation(translations, term, locale)

  if (typeof translation === 'undefined') {
    translation = getTranslation(translations, term, defaultLocale)
  }

  Object.entries(props).forEach(
    ([key, value]) => (translation = translation?.replaceAll(`{${key}}`, value))
  )

  return translation ?? ''
}

const getTranslation = (
  translations: Translations,
  term: string,
  locale: Locale
) => {
  let result = undefined

  if (term.toString().includes('.')) {
    const arr = term.split('.')
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let path: any = undefined

    arr.map((item: string) => {
      if (!path) {
        path = translations[locale]?.[item]
      } else {
        path = path[item]
      }
    })

    result = path
  }

  if (!result) {
    result = translations[locale]?.[term]
  }

  return result
}
